import {forwardRef} from 'react'

import PropTypes from 'prop-types'

import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'

// Every icon control in the gallery (arrows, close, play) is the same negative circular button
// over media; only the icon, the variant and the handler change.
// forwardRef is required: <DialogClose asChild> clones this element and hands it a ref.
const GalleryIconButton = forwardRef(({icon: IconComponent, variant = BUTTON_VARIANTS.SOLID, ...props}, ref) => (
  <Button
    ref={ref}
    type="button"
    intent={BUTTON_INTENTS.PRIMARY}
    shape={BUTTON_SHAPES.CIRCLE}
    size={BUTTON_SIZES.LARGE}
    variant={variant}
    negative
    {...props}
  >
    <Icon size={ICON_SIZES.MD}>
      <IconComponent size={ICON_SIZES.MD} />
    </Icon>
  </Button>
))

GalleryIconButton.displayName = 'GalleryIconButton'

GalleryIconButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  variant: PropTypes.string
}

export default GalleryIconButton
